import {formatDate} from '@angular/common';


/**
 * Fassung der Datenschutzerklärung, die das Dokument in diesem Verzeichnis wiedergibt.
 *
 * Sie steht neben dem Text und nicht in der Umgebungs- oder Laufzeitkonfiguration, weil die
 * Zustimmung bescheinigen soll, was der Nutzer gelesen hat: Aus einer anderen Quelle könnte sie
 * unbemerkt vom Text abweichen.
 *
 * Verglichen wird auf Gleichheit; eine Reihenfolge ist nicht zugesichert, und die Datumsform ist
 * Konvention.
 */
export const PRIVACY_POLICY_VERSION = '2026-10-15';

/**
 * Fassungen, die als Datum geschrieben sind, und nur diese werden als Datum angezeigt.
 *
 * Die Prüfung auf genau diese Form ist nötig, weil formatDate bei einem unpassenden Wert nicht
 * scheitert: "Fassung-7" ergibt dort den 01.07.2001. Ein erfundenes Datum in einem Rechtstext ist
 * schlimmer als eine fehlende Angabe, auf einen abgefangenen Fehler ist also kein Verlass.
 */
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Bereitet eine Fassung für die Anzeige als Stand-Angabe auf.
 *
 * Nur ein Wert in Datumsform wird umgeschrieben; jeder andere erscheint unverändert, statt in ein
 * Datum gebogen zu werden. Ohne Fassung gibt es keine Stand-Zeile.
 */
export function formatPrivacyPolicyVersion(
  version: string,
  locale: string,
): string | null {
  if (!version) {
    return null;
  }
  if (!ISO_DATE.test(version)) {
    return version;
  }
  try {
    return formatDate(version, 'dd.MM.yyyy', locale);
  } catch (error) {
    // INFO: Fehlende Locale-Daten etwa. An der Stand-Zeile darf die Erklärung nicht scheitern.
    return version;
  }
}
